/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlayerSearchResultDTO { 
    player_id: string;
    player_name: string;
    team_id: string;
    team_name: string;
    season_id: number;
}

